(function () {
  'use strict';

  var syncing = false;

  function cartRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function cartUrl(path) {
    return cartRoot() + path;
  }

  function getProp(item, key) {
    if (!item || !item.properties) return '';
    return item.properties[key] || '';
  }

  function getDesignProp(item) {
    return getProp(item, '_Design') || getProp(item, 'Design');
  }

  function getAppliesProp(item) {
    return getProp(item, 'Applies to') || getProp(item, 'Applies To');
  }

  function getCustomSku(item) {
    return getProp(item, '_SKU') || getProp(item, 'SKU') || getProp(item, 'Sku');
  }

  function getFeeType(item) {
    return getProp(item, '_fee_type');
  }

  function getFeePairedSku(item) {
    return getProp(item, '_paired_sku') || getProp(item, 'Applies to SKU') || '';
  }

  function titleLooksLikeFee(title) {
    var lc = (title || '').toLowerCase();
    return lc.indexOf('artisan commission') !== -1 ||
      lc.indexOf('customization fee') !== -1;
  }

  function isSetupFeeLine(item) {
    if (!item) return false;
    if (getFeeType(item) === 'setup') return true;
    return titleLooksLikeFee(item.product_title || item.title || '') &&
      (item.product_title || item.title || '').toLowerCase().indexOf('setup') !== -1;
  }

  function isPerBoxFeeLine(item) {
    if (!item) return false;
    if (getFeeType(item) === 'per-box') return true;
    if (getFeeType(item) === 'setup') return false;
    if (getProp(item, 'Applies to')) return true;
    if (getFeePairedSku(item)) return true;
    var title = (item.product_title || item.title || '').toLowerCase();
    return title.indexOf('per box') !== -1 ||
      (title.indexOf('artisan commission') !== -1 && title.indexOf('setup') === -1) ||
      title.indexOf('customization fee') !== -1;
  }

  function isCommissionFeeLine(item) {
    return isSetupFeeLine(item) || isPerBoxFeeLine(item);
  }

  function isCustomFullSizeLine(item) {
    if (!item) return false;

    var design = getDesignProp(item);
    if (design) {
      var designLc = design.toLowerCase();
      if (designLc.indexOf('custom colorway sample') !== -1) return false;
      if (designLc.indexOf('custom colorway') !== -1) return true;
    }

    var variantTitle = (item.variant_title || '').toLowerCase();
    if (variantTitle.indexOf('sample') !== -1) return false;

    var title = (item.product_title || '').toLowerCase();
    if (title.indexOf('custom colorway') !== -1 && title.indexOf('sample') === -1) return true;
    if (variantTitle === 'full size' && title.indexOf('custom') !== -1) return true;

    return false;
  }

  function getConfiguredVariantIds() {
    var cfg = window.ZellijArtisanCommission || {};
    return {
      setup: cfg.setupVariantId ? parseInt(cfg.setupVariantId, 10) : null,
      perBox: cfg.perBoxVariantId ? parseInt(cfg.perBoxVariantId, 10) : null
    };
  }

  function getVariantIdsFromCart(cart) {
    var configured = getConfiguredVariantIds();
    var setupId = configured.setup;
    var perBoxId = configured.perBox;

    (cart.items || []).forEach(function (item) {
      if (isSetupFeeLine(item) && !setupId) setupId = item.variant_id;
      if (isPerBoxFeeLine(item) && !perBoxId) perBoxId = item.variant_id;
    });

    return { setup: setupId, perBox: perBoxId };
  }

  function buildCommissionSyncPlan(cart) {
    var updates = {};
    var additions = [];
    var customLines = cart.items.filter(isCustomFullSizeLine);
    var setupLines = cart.items.filter(isSetupFeeLine);
    var perBoxLines = cart.items.filter(isPerBoxFeeLine);
    var variantIds = getVariantIdsFromCart(cart);
    var totalCustomBoxes = customLines.reduce(function (sum, line) {
      return sum + line.quantity;
    }, 0);

    if (!customLines.length) {
      setupLines.concat(perBoxLines).forEach(function (fee) {
        if (fee.quantity !== 0) updates[fee.key] = 0;
      });
      return { updates: updates, additions: additions };
    }

    var setupLine = setupLines[0];
    if (setupLine) {
      if (setupLine.quantity !== 1) updates[setupLine.key] = 1;
    } else if (variantIds.setup) {
      additions.push({
        id: variantIds.setup,
        quantity: 1,
        properties: { _fee_type: 'setup' }
      });
    }

    setupLines.slice(1).forEach(function (extraSetup) {
      if (extraSetup.quantity !== 0) updates[extraSetup.key] = 0;
    });

    var perBoxLine = perBoxLines[0];
    if (perBoxLine) {
      if (perBoxLine.quantity !== totalCustomBoxes) {
        updates[perBoxLine.key] = totalCustomBoxes;
      }
    } else if (variantIds.perBox && totalCustomBoxes > 0) {
      additions.push({
        id: variantIds.perBox,
        quantity: totalCustomBoxes,
        properties: { _fee_type: 'per-box' }
      });
    }

    perBoxLines.slice(1).forEach(function (extraPerBox) {
      if (extraPerBox.quantity !== 0) updates[extraPerBox.key] = 0;
    });

    return { updates: updates, additions: additions };
  }

  function cartNeedsCommissionSync(cart) {
    var plan = buildCommissionSyncPlan(cart);
    return Object.keys(plan.updates).length > 0 || plan.additions.length > 0;
  }

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function applyCommissionSync(cart) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(null);

    var plan = buildCommissionSyncPlan(cart);
    var updateKeys = Object.keys(plan.updates);
    if (!updateKeys.length && !plan.additions.length) return Promise.resolve(null);

    var promise = Promise.resolve(cart);

    if (updateKeys.length) {
      promise = promise.then(function () {
        return fetch(cartUrl('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: plan.updates })
        }).then(function (response) {
          if (!response.ok) return null;
          return response.json();
        });
      });
    }

    if (plan.additions.length) {
      promise = promise.then(function (currentCart) {
        if (currentCart === null) return null;

        return fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: plan.additions })
        }).then(function (response) {
          if (!response.ok) return null;
          return response.json();
        }).then(function () {
          return fetch(cartUrl('cart.js')).then(function (response) {
            return response.json();
          });
        });
      });
    }

    return promise.then(function (resultCart) {
      if (!resultCart || !plan.additions.length) return resultCart;

      var followUp = buildCommissionSyncPlan(resultCart);
      if (!Object.keys(followUp.updates).length) return resultCart;

      return fetch(cartUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: followUp.updates })
      }).then(function (response) {
        if (!response.ok) return resultCart;
        return response.json();
      });
    });
  }

  function runSync(cart, options) {
    if (syncing) return Promise.resolve(null);
    syncing = true;

    return applyCommissionSync(cart)
      .then(function (updatedCart) {
        if (!updatedCart) return null;

        if (options && options.reloadCartPage) {
          window.location.reload();
          return updatedCart;
        }

        refreshCartUi();
        return updatedCart;
      })
      .finally(function () {
        syncing = false;
      });
  }

  function syncFromServer(options) {
    return fetch(cartUrl('cart.js'))
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cartNeedsCommissionSync(cart)) return null;
        return runSync(cart, options);
      })
      .catch(function () { return null; });
  }

  function onCartChanged(event) {
    if (!event.detail || event.detail.baseEvent === 'zellij:fee-sync') return;
    var cart = event.detail.cart;
    if (!cart || !cartNeedsCommissionSync(cart)) return;
    runSync(cart);
  }

  document.addEventListener('cart:change', onCartChanged);

  document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('template-cart') ||
        window.location.pathname.endsWith('/cart')) {
      syncFromServer({ reloadCartPage: true });
    }
  });

  window.ZellijCartFeeSync = {
    syncFromServer: syncFromServer,
    runSync: runSync,
    buildFeeSyncPlan: buildCommissionSyncPlan
  };

  window.ZellijCartCommissionSync = window.ZellijCartFeeSync;
})();
